import angular from 'angular';
import plugins from '../Components/Plugins/plugins.component';
import plugin from '../Components/Plugins/plugin/plugin.component';

export default angular
    .module('app.integrations.plugins', [])
    .component("plugins", plugins)
    .component("plugin", plugin)
    .name;